import React, { useState } from "react";
import loginStyles from "./NewLogin.module.css";
import { Header } from "../Header/Header";
import loginbg from "../../img/loginbg.png";
import { HiOutlineMail } from "react-icons/hi";
import { FaRegEye, FaRegEyeSlash } from "react-icons/fa6";
import { ContactGetStartBtn } from "../Contact GetStart btn/ContactGetStartBtn";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import { Link } from "react-router-dom";
import LoadingButton from "../../HOC/LoadingButton";
import BottomActionBtn from "../../BottomActionBtn";
import { useLocation } from "react-router-dom";
import { useDispatch } from "react-redux";
import { loginUser } from "../../../redux/allAction/authThunks";
import { IoClose } from "react-icons/io5";
import { useChatBundleContext } from '../../../contexts/ChatBundleContext';

const backend_api_base_url = `${process.env.REACT_APP_SL_BE_BASE_ENV_PART}/${process.env.REACT_APP_STAGE_ENV}`;

export const NewLogin = () => {
  const location = useLocation();
  const new_history = useHistory();
  const dispatch = useDispatch();

  // Use the chat bundle hook - initially disabled, will enable after login
  const { enableBundle, loading: bundleLoading } = useChatBundleContext();

  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [userType, setUserType] = useState("tenant_type");
  const [showPassword, setShowPassword] = useState(false);

  const [showErrorPopup, setShowErrorPopup] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");

  const [isLoading, setIsLoading] = useState(false);

  const togglePassVisibility = () => setShowPassword(!showPassword);

  console.log("errorMessage", errorMessage)
  // -------------------------------------------------------------
  //  HANDLE SUBMIT
  // -------------------------------------------------------------
  const handleSubmit = async (event) => {
    event.preventDefault();
    setIsLoading(true);

    try {
      await dispatch(
        loginUser(email, password, userType, backend_api_base_url)
      );

      // Enable bundle loading after successful login
      enableBundle();

      // redirect
      const redirectTo = location.state?.from?.pathname || "/all_chats";
      new_history.push(redirectTo);
    } catch (err) {
      setErrorMessage(err.message);
      setShowErrorPopup(true);
    } finally {
      setIsLoading(false);
    }
  };

  const closePopup = () => {
    setShowErrorPopup(false);
    setErrorMessage("");
  };

  // -------------------------------------------------------------
  //  SHOW LOADER IF BUNDLE IS LOADING (after login)
  // -------------------------------------------------------------
  if (bundleLoading) {
    return (
      <div style={{ padding: "40px", textAlign: "center", fontSize: "20px" }}>
        Loading chat...
      </div>
    );
  }

  // -------------------------------------------------------------
  //  NORMAL LOGIN UI
  // -------------------------------------------------------------
  return (
    <div className={loginStyles.wrapper}>
      <Header />
      <div className={loginStyles.loginContainer}>
        <img src={loginbg} alt="bg" />
        <div className={loginStyles.loginContent}>
          <div className={loginStyles.login_left}>
            <h1>Sageion</h1>
            <p>An Enterprise AI Agent for Customer Operations</p>
          </div>

          <div className={loginStyles.login}>
            <h3>Login to Your Account</h3>
            <form className={loginStyles.loginForm} onSubmit={handleSubmit}>
              {/* EMAIL */}
              <div className={loginStyles.formGroup}>
                <label htmlFor="email">Email:</label>
                <div className={loginStyles.inputWrapper}>
                  <input
                    type="email"
                    id="email"
                    placeholder="Enter your email id"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    required
                  />
                  <HiOutlineMail className={loginStyles.inputIcon} />
                </div>
              </div>

              {/* PASSWORD */}
              <div className={loginStyles.formGroup}>
                <label htmlFor="password">Password:</label>
                <div className={loginStyles.inputWrapper}>
                  <input
                    type={showPassword ? "text" : "password"}
                    id="password"
                    placeholder="Enter your password"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    required
                  />
                  <button
                    type="button"
                    onClick={togglePassVisibility}
                    className={loginStyles["password-toggle-button"]}
                  >
                    {showPassword ? <FaRegEye /> : <FaRegEyeSlash />}
                  </button>
                </div>
              </div>

              {/* USER TYPE */}
              <div className={loginStyles.formGroup}>
                <label>User Type:</label>
                <div className={loginStyles.userType}>
                  <label>
                    <input
                      type="radio"
                      name="userType"
                      value="tenant_type"
                      checked={userType === "tenant_type"}
                      onChange={(e) => setUserType(e.target.value)}
                    />
                    Tenant
                  </label>

                  <label >
                    <input
                      type="radio"
                      name="userType"
                      value="support_type"
                      checked={userType === "support_type"}
                      onChange={(e) => setUserType(e.target.value)}
                    />
                    Support
                  </label>
                </div>
              </div>

              {/* Forgot Password */}
              <div className={loginStyles.forgotPassword}>
                <a href="/forgot_password">Forgot Password?</a>
              </div>

              {/* LOGIN BUTTON */}
              <LoadingButton
                type="submit"
                isLoading={isLoading}
                className={loginStyles.button}
              >
                Login
              </LoadingButton>

              <div className={loginStyles.signupLink}>
                <span>Don't have an account?</span>
                <Link to="/signup">Sign up</Link>
              </div>
            </form>
          </div>
        </div>

        <BottomActionBtn
          buttons={[
            { text: "Get started", onClick: () => console.log("Start") },
            { text: "Contact us", onClick: () => console.log("Contact") },
          ]}
        />
      </div>

      {showErrorPopup && (
        <div className={loginStyles.errorPopup}>
          <div className={loginStyles.errorPopupContent}>
            <h4>Error</h4>
            <button onClick={closePopup} className={loginStyles.close}>
              <IoClose />
            </button>
            <p>{errorMessage}</p>
          </div>
        </div>
      )}
    </div>
  );
};
